import axios from 'axios';
import { getSessionToken } from '@shopify/app-bridge/utilities';

const instance = axios.create();

// Intercept all requests on this Axios instance
instance.interceptors.request.use((config) => {
  // check if Shopify App Bridge instance exists
  if (!window.assortion) return config;

  return getSessionToken(window.assortion).then((token) => {
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  });
});

export default instance;
